export default __webpack_public_path__ + "static/media/logolimena-ethnix.6068b060.png";